// extracted by mini-css-extract-plugin
module.exports = {"container":"_3NTLX","container2":"Otio7","languages":"_1SgD_","language":"_58POS","lastColumn":"_3ziXJ","link":"_1yh1d","selected":"_1uQnc","closeButton":"fWpKl","biLink":"_35k0-"};